export const tripStatusFormatter = status => {
  if (status === 'ARRIVED') return 'Arrived'
  if (status === 'CANCELED' || status === 'CANCELLED') return 'Canceled'
  if (status === 'COMPLETED') return 'Completed'
  if (status === 'NO_DRIVER_FOUND') return 'No Driver Found'
  if (status === 'LOOKING_FOR_DRIVER') return 'Looking For A Driver'
  if (status === 'CREATED') return 'Created'
  if (status === 'ACCEPTED') return 'Accepted'
  if (status === 'IN_PROGRESS') return 'In Progress'
  return status
}

export const tripColorGenerator = status => {
  if (status === 'ARRIVED') return 'cyan'
  if (status === 'CANCELED' || status === 'CANCELLED') return 'danger'
  if (status === 'COMPLETED') return 'success'
  if (status === 'NO_DRIVER_FOUND') return 'secondary'
  if (status === 'LOOKING_FOR_DRIVER') return 'info'
  if (status === 'CREATED') return 'purple'
  if (status === 'ACCEPTED') return 'yellow'
  if (status === 'IN_PROGRESS') return 'warning'
  return status
}
export const tripPathMarkerIcon = status => {
  if (status === 'ACCEPTED') return 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png'
  if (status === 'ARRIVED') return 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
  if (status === 'IN_PROGRESS') return 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png'
  if (status === 'COMPLETED') return 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
  if (status === 'CANCELED' || status === 'CANCELLED') return 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
  return status
}

export const tripIconGenerator = status => {
  if (status === 'ARRIVED') return 'TruckIcon'
  if (status === 'CANCELED' || status === 'CANCELLED') return 'XIcon'
  if (status === 'COMPLETED') return 'CheckCircleIcon'
  if (status === 'NO_DRIVER_FOUND') return 'AlertTriangleIcon'
  if (status === 'LOOKING_FOR_DRIVER') return 'SearchIcon'
  if (status === 'CREATED') return 'CalendarIcon'
  if (status === 'ACCEPTED') return 'FlagIcon'
  if (status === 'IN_PROGRESS') return 'LoaderIcon'
  return status
}
